module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjMDAwMGI0IiBkPSJNMCAwaDUxMS45OTN2NTExLjk4NEgweiIvPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgODAuNDU1aDUxMS45OTN2MzQzLjc2MkgweiIvPgogICAgPHBhdGggZmlsbD0iI2Q5MDAwMCIgZD0iTTAgMTY4LjIyMmg1MTEuOTkzdjE2OC4yMjJIMHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/cr.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/cr.svg
// module chunks = 0